import React from 'react'
import { ProductImageWrapper } from '../../components/product-images-generator/styles'

export const Casement22Square82Casement = () => {
  return (
    <ProductImageWrapper>
      <svg
        width="220"
        height="333"
        viewBox="0 0 220 333"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#5filter0_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M192 38.9995C192 37.8952 191.105 37 190.001 37C188.896 37 188.001 37.8952 188.001 38.9995V41.1665H188.001V52H188V55.0005C188 56.1048 188.895 57 189.999 57C191.104 57 191.999 56.1048 191.999 55.0005V52.8332H192V42H192V38.9995Z"
            fill="url(#paint0_linear)"
          />
        </g>
        <rect
          width="3.99896"
          height="11.6667"
          transform="matrix(-1 0 0 1 192 41.1665)"
          fill="#ABABAB"
        />
        <path
          d="M192 37.9399C192 37.4208 191.579 37 191.06 37H188.941C188.422 37 188.001 37.4208 188.001 37.9399V42H192V37.9399Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M188 56.0601C188 56.5792 188.421 57 188.94 57H191.059C191.578 57 191.999 56.5792 191.999 56.0601V52H188V56.0601Z"
          fill="url(#paint2_linear)"
        />
        <rect
          width="3.99896"
          height="8.33334"
          transform="matrix(-1 0 0 1 192 42.8335)"
          fill="url(#paint3_linear)"
        />
        <g filter="url(#5filter1_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188 63C188 61.8954 188.895 61 190 61C191.105 61 192 61.8954 192 63V77.5599H188V63ZM188 77.5602H192V79.4H192.06C192.579 79.4 193 79.8209 193 80.34V82.1201C193 83.1584 192.158 84 191.12 84H189.88C188.842 84 188 83.1584 188 82.1201V79.4002V79.4V77.5602Z"
            fill="white"
          />
        </g>
        <rect x="188" y="78.25" width="3.99998" height="0.95833" fill="#ABABAB" />
        <path
          d="M188 61.9399C188 61.4208 188.421 61 188.94 61H191.06C191.579 61 192 61.4208 192 61.9399V78.2499H188V61.9399Z"
          fill="url(#paint4_linear)"
        />
        <path
          d="M188 83.0601C188 83.5792 188.421 84 188.94 84H192.06C192.579 84 193 83.5792 193 83.0601V80.1483C193 79.6292 192.579 79.2083 192.06 79.2083H188V83.0601Z"
          fill="url(#paint5_linear)"
        />
        <g filter="url(#5filter2_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188 33H115V88H188V33ZM178 43H125V78H178V43Z"
            fill="#E8EAEE"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M188 33H115V88H116V34H187V88H188V33Z"
          fill="#FBFBFB"
        />
        <g filter="url(#5filter3_i)">
          <rect
            x="125.47"
            y="43.47"
            width="52.0601"
            height="34.0601"
            stroke="#979797"
            strokeWidth="0.93994"
          />
        </g>
        <rect
          x="119.53"
          y="37.53"
          width="63.9399"
          height="45.9399"
          stroke="#E2E4E8"
          strokeWidth="0.93994"
        />
        <rect
          x="117"
          y="53"
          width="7"
          height="13.5283"
          rx="3.5"
          fill="#9B9DA2"
          fillOpacity="0.19"
        />
        <g filter="url(#5filter4_d)">
          <rect x="117.702" y="53.644" width="5.6" height="12.2399" rx="2.8" fill="#E8EAEE" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M118.286 64.7956C118.798 65.4577 119.6 65.8841 120.502 65.8841C122.048 65.8841 123.302 64.6305 123.302 63.0841V56.4442C123.302 55.4557 122.79 54.5869 122.016 54.0886C122.382 54.5619 122.6 55.1556 122.6 55.8001V62.44C122.6 63.9864 121.347 65.24 119.8 65.24C119.242 65.24 118.722 65.0768 118.286 64.7956Z"
          fill="#DFE0E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.502 53.644C118.956 53.644 117.702 54.8976 117.702 56.444V62.4397C117.702 62.4601 117.702 62.4805 117.703 62.5007V57.0236C117.703 55.4772 118.956 54.2236 120.503 54.2236C122.029 54.2236 123.269 55.4444 123.302 56.9627V56.444C123.302 54.8976 122.048 53.644 120.502 53.644Z"
          fill="#FBFBFB"
        />
        <g filter="url(#5filter5_d)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M120.5 57C119.672 57 119 57.6716 119 58.5V58.7143V60V78.5C119 79.3284 119.672 80 120.5 80V80C121.328 80 122 79.3284 122 78.5V62V58.5L122 58.2857C122 57.5756 121.424 57 120.714 57V57C120.677 57 120.64 57.0012 120.604 57.0035C120.569 57.0012 120.535 57 120.5 57Z"
            fill="#E8EAEE"
          />
        </g>
        <path d="M176.5 76.3063L127.624 60.0144L176.5 44.6809L176.5 76.3063Z" stroke="white" />
        <path d="M127.018 76.5L151.5 44.8177L175.982 76.5H127.018Z" stroke="white" />
        <defs>
          <filter
            id="5filter0_d"
            x="186.12"
            y="35.1201"
            width="9.63962"
            height="25.6396"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="5filter1_d"
            x="186.12"
            y="59.1201"
            width="10.6396"
            height="28.6397"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="5filter2_d"
            x="110.3"
            y="28.3003"
            width="84.2793"
            height="66.2793"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="2.81982" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="5filter3_i"
            x="125"
            y="43"
            width="53.9399"
            height="37.8198"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="0.93994" dy="2.81982" />
            <feGaussianBlur stdDeviation="1.87988" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          </filter>
          <filter
            id="5filter4_d"
            x="115.822"
            y="51.7642"
            width="11.2396"
            height="17.8795"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <filter
            id="5filter5_d"
            x="117.12"
            y="55.1201"
            width="8.63964"
            height="28.6396"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="0.93994" dy="0.93994" />
            <feGaussianBlur stdDeviation="1.40991" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.256181 0 0 0 0 0.256898 0 0 0 0 0.258333 0 0 0 0.56 0"
            />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear"
            x1="194.8"
            y1="54.5"
            x2="187.2"
            y2="54.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#E0E0E1" />
            <stop offset="0.999276" stopColor="white" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="185.202"
            y1="39.5"
            x2="192.8"
            y2="39.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="194.798"
            y1="54.5"
            x2="187.2"
            y2="54.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="paint3_linear"
            x1="6.79822"
            y1="4.16667"
            x2="-0.799791"
            y2="4.16667"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="paint4_linear"
            x1="194.8"
            y1="69.625"
            x2="187.2"
            y2="69.625"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
          <linearGradient
            id="paint5_linear"
            x1="196.5"
            y1="81.6042"
            x2="187"
            y2="81.6042"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.340644" stopColor="#E0E0E1" />
            <stop offset="0.630803" stopColor="white" />
            <stop offset="1" stopColor="#E0E2E6" />
          </linearGradient>
        </defs>
      </svg>
    </ProductImageWrapper>
  )
}
